import { get, post } from "../common/dataFetch";
import { ZipDetail } from "../store/ZipCodeLookUpStore";
 
export const getZipCodeDetail = (zipCode: string) => post<ZipDetail[]>(`ZipCodeLookup/ReadExtendedByZipCode?zipCode=${zipCode}`, null);
 
export const getZipCodeByCityState = (zipdetail: ZipDetail) => post<ZipDetail[]>(`ZipCodeLookup/ReadExtendedByCityState`, { ...zipdetail });

